module.exports = __webpack_public_path__ + "assets/img/Enginio_logotype_horizontal_neg.90b63572.png";